import Vue from 'vue';
import Router from 'vue-router';
import auth from '../utils/auth';

Vue.use(Router);

function CASRedirection(next, login) {
  auth.getCASConf()
    .then((response) => {
      if (response.CONF.CAS_ENABLED) {
        window.location.href = `${process.env.API_CAS}/login`;
      } else if (login) {
        if (window.location.hostname === 'amtrust.deskrh.fr') {
          next({ name: 'LoginAMTrust' });
        } else {
          next();
        }
      } else if (window.location.hostname === 'amtrust.deskrh.fr') {
        next({ name: 'LoginAMTrust' });
      } else {
        next({ name: 'Login' });
      }
    });
}

function redirectToDefaultPage(next) {
  if (!auth.requireAuth()) {
    CASRedirection(next);
  } else if (auth.getSessionUserNeedFinalization()) {
    next({ name: 'RecapPage' });
  } else {
    next();
  }
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'DashboardHome',
      component: () => import('@/pages/dashboard/index.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/ged',
      name: 'GedHome',
      component: () => import('@/pages/ged/index.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/organizations',
      name: 'OrganizationsHome',
      component: () => import('@/pages/organizations/index.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/sign-workflow',
      name: 'SignWorkflowHome',
      component: () => import('@/pages/signWorkflow/index.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: () => import('@/pages/maintenance/index.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },

    /* Campaigns */
    {
      path: '/campaigns',
      name: 'campaigns.index',
      component: () => import('@/pages/campaigns/index.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/campaigns/create',
      name: 'campaigns.create',
      component: () => import('@/pages/campaigns/create.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },

    {
      path: '/campaigns/:campaignId',
      name: 'campaigns.show',
      component: () => import('@/pages/campaigns/show.vue'),
      props: true,
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },

    /* Admin */
    {
      path: '/admin/rights',
      name: 'admin.rights.index',
      component: () => import('@/pages/admin/rights/index.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/admin/rights/users',
      name: 'admin.rights.users.index',
      component: () => import('@/pages/admin/rights/users/index.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/admin/rights/users/create',
      name: 'admin.rights.users.create',
      component: () => import('@/pages/admin/rights/users/create.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/admin/rights/users/:userId/edit',
      name: 'admin.rights.users.edit',
      component: () => import('@/pages/admin/rights/users/edit.vue'),
      props: true,
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/admin/rights/rules',
      name: 'admin.rights.rules.index',
      component: () => import('@/pages/admin/rights/rules/index.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/admin/rights/rules/create',
      name: 'admin.rights.rules.create',
      component: () => import('@/pages/admin/rights/rules/create.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/admin/rights/rules/:ruleId',
      name: 'admin.rights.rules.show',
      component: () => import('@/pages/admin/rights/rules/show.vue'),
      props: true,
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/admin/rights/rules/:ruleId/edit',
      name: 'admin.rights.rules.edit',
      component: () => import('@/pages/admin/rights/rules/edit.vue'),
      props: true,
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/admin/rights/groups',
      name: 'admin.rights.groups.index',
      component: () => import('@/pages/admin/rights/groups/index.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/admin/rights/groups/create',
      name: 'admin.rights.groups.create',
      component: () => import('@/pages/admin/rights/groups/create.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/admin/rights/groups/:groupId/edit',
      name: 'admin.rights.groups.edit',
      component: () => import('@/pages/admin/rights/groups/edit.vue'),
      props: true,
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/admin/account',
      name: 'admin.account.index',
      component: () => import('@/pages/account/index.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },

    /* Organizations */

    /* Signworkflows */
    {
      path: '/sign-workflow/templates',
      name: 'SignWorkflowTemplates',
      component: () => import('@/pages/signWorkflow/SignWorkflowTemplates'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '/sign-workflow/done',
      name: 'SignWorkflowDone',
      component: () => import('@/pages/signWorkflow/SignWorkflowDone'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },

    /* Partnership */
    {
      path: '/partnership',
      name: 'PartnershipHome',
      component: () => import('@/pages/partnerships/index.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },

    {
      path: '/partnership/create',
      name: 'PartnershipCreate',
      component: () => import('@/pages/partnerships/partnershipCreate.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },

    {
      path: '/partnership/show/:thirdPartyId',
      name: 'PartnershipShow',
      props: true,
      component: () => import('@/pages/partnerships/partnershipShow.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },

    {
      path: '/partnership/groups',
      name: 'PartnershipGroups',
      component: () => import('@/pages/partnerships/partnershipsGroups.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },

    {
      path: '/partnership/groups/create',
      name: 'PartnershipsGroupsCreate',
      component: () => import('@/pages/partnerships/partnershipsGroupCreate.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },


    {
      path: '/partnership/groups/show/:groupId',
      name: 'PartnershipGroupShow',
      component: () => import('@/pages/partnerships/partnershipsGroupShow.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },

    {
      path: '/partnership/finalize',
      name: 'FinalizePartnerships',
      component: () => import('@/pages/partnerships/partnershipsNotValidated.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },

    {
      path: '/partnership/created',
      name: 'PartnershipCreated',
      component: () => import('@/pages/partnerships/partnershipCreated.vue'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },

    {
      path: '/renew-direct-doc-download-link',
      name: 'RenewDirectDocDownloadLink',
      props: route => route.query,
      component: () => import('@/pages/ged/DirectDocDownload/RenewDirectDocDownloadLink.vue'),
    },

    {
      path: '/login-am',
      name: 'LoginAMTrust',
      component: () => import('@/pages/login/amtrust'),
    },

    {
      path: '/login',
      name: 'Login',
      component: () => import('@/pages/login/index'),
      beforeEnter(to, from, next) {
        if (auth.requireAuth()) {
          next({ path: '/' });
        } else {
          CASRedirection(next, true);
        }
      },
    },

    {
      path: '/autologin',
      redirect: (to) => {
        if (to.query.authorization && to.query.authorization.length &&
          to.query.refreshToken && to.query.refreshToken.length) {
          auth.CASLogin(to.query);
          return { path: '/', query: undefined };
        }
        return { path: '/login' };
      },
    },

    {
      path: '/guest/:login/:password',
      name: 'Guest',
      redirect: (to) => {
        auth.logout();
        // console.log(to, auth.isLoggedIn());
        return { name: 'Login', params: to.params };
      },
    },

    {
      path: 'your-files',
      name: 'RecapPage',
      component: () => import('@/pages/recap/index'),
      beforeEnter(to, from, next) {
        next();
      },
    },

    {
      path: '/chorus',
      name: 'ChorusHome',
      component: () => import('@/pages/chorus/index'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },

    {
      path: '/chorus/sent',
      name: 'ChorusSent',
      component: () => import('@/pages/chorus/chorusSent'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },

    {
      path: '/chorus/add',
      name: 'ChorusAdd',
      component: () => import('@/pages/chorus/add'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },

    {
      path: '/collectors',
      name: 'Collectors',
      component: () => import('@/pages/collectors/index'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },

    {
      path: '/collectors/not-subcribed',
      name: 'NotSubscribedCollectors',
      component: () => import('@/pages/collectors/notSubscribedCollectors'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },

    {
      path: '/collectors/wrong-identifiers',
      name: 'WrongIdentifiers',
      component: () => import('@/pages/collectors/routingWrongIdentifiers'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },

    {
      path: '/collectors/collect-error',
      name: 'CollectError',
      component: () => import('@/pages/collectors/routingCollectError'),
      beforeEnter(to, from, next) {
        redirectToDefaultPage(next);
      },
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js